import { useEffect, useState } from 'react'
import { chapters } from '../data/horizon'

export function useActiveChapter() {
  const [active, setActive] = useState(chapters[0].id)

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        const v = entries.filter((e) => e.isIntersecting)
        if (v.length) setActive(v[0].target.id)
      },
      { rootMargin: '-30% 0px -60% 0px' },
    )
    chapters.forEach((c) => {
      const el = document.getElementById(c.id)
      if (el) obs.observe(el)
    })
    return () => obs.disconnect()
  }, [])

  return active
}
